import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResultByDimensionEngagementDomain = (state) =>
  state.get("widgetResultByDimensionEngagementV2", initialState)

export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("showDimensionBenchmark")
  )

const makeSelectWidgetResultByDimensionEngagement = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimensionEngagement
export { selectWidgetResultByDimensionEngagementDomain }
